
import React from 'react';

const ServiceCard = ({ image, title, desc }) => {
  return (
    <div className="bg-[#242424] lg:p-6 p-2 flex items-start lg:gap-4 gap-3 hover:shadow-md transition">
      <img src={image} alt="Service Icon" className="mt-1 w-16 h-16 lg:w-[100px] lg:h-[100px]" />
      <div className='ml-2'>
        <h3 className="text-body  lg:mt-4 mt-2 font-dmsans font-medium lg:text-[24px] text-[#FFFFFF]  ">{title}</h3>
        <p className="text-body-sm lg:text-body font-normal font-roboto lg:mt-3 mt-1 text-[#9E9E9E]">{desc}</p>
      </div>
    </div>
  );
};

export default ServiceCard;
